import { useContext } from 'react'
import { ServiceContext  } from './ServiceContext'

export const findService = (id:string, services: any) => {
    const service = services && services.find((service:any) => {
        return service.id === id
    })

    if (!service) {
        throw new Error(`Service "${id}" not found.`)
    }

    return service.value
}

function useDocumentService<T = unknown>(id: string): T {
    const context = useContext(ServiceContext)

    return findService(id, context)
}


export { useDocumentService }
